import React from 'react'
// Import Swiper React components
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { graphql, StaticQuery } from 'gatsby'
// Import Swiper styles

import 'swiper/modules/autoplay/autoplay.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/scrollbar/scrollbar.scss'; // Navigation module
import 'swiper/modules/pagination/pagination.scss'; // Pagination module

import './swiper.scss'; // core Swiper

const SliderOpinions = (props) => {

  let names = []
  let opinions = []

 //console.log(props.data.allMarkdownRemark.edges)
  props.data.allMarkdownRemark.edges[0].node.frontmatter.opinions.forEach((item, i) => {
    names.push(item.name)
    opinions.push(item.opinion)
  });


  return (
    <>
    <div style={{backgroundColor:'rgba(0,0,0,.85)',maxWidth:'90%',margin:'5%',padding:'5%',borderRadius:'25px',textAlign:'center',boxShadow:'0 0.5em 1em -0.125em rgba(17, 15, 31, 0.1), 0 0px 0 1px rgba(17, 15, 31, 0.02)'}}>
    <br />
    <img width="200px" height="40.77px" loading="lazy"  style={{verticalAlign:'middle'}}   alt="rating" src='/img/rating-5.svg'/>
    <br />
    <Swiper
      // install Swiper modules
      modules={[Navigation, Pagination, A11y, Scrollbar, Autoplay]}
      slidesPerView={1}
      spaceBetween={20}
      navigation
      autoplay={true}
      loop={true}
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
    >
    {names.map((el, i, isActive) => {
     return <SwiperSlide key={el+i}>

     {({ isNext }) => (
     <div style={{padding:'5%',margin:'0 20px',textAlign:'center'}}>
     <div style={{display:'flex',justifyContent:'center'}}>

     </div>
     <p className="subtitle native-lang">
     {opinions[i]}
     <br /><br />
     <sup className="subtitle native-lang"> {names[i]}</sup></p>
     </div>
     )}

     </SwiperSlide>;
   })}
    </Swiper>
    <br /><br />
    <p style={{textAlign:'center'}}>
    <a className="btnblog" style={{border:'1px solid #36b3d2'}} target="_blank" rel='noopener noreferrer'
    href="https://www.google.com/search?q=e-multicontent&ei=fJcWYcbkFYrekwWd04K4BA&oq=e-multicontent&gs_lcp=Cgdnd3Mtd2l6EAM6BwgAEEcQsAM6CAgAEIAEELEDOgUIABCABDoRCC4QgAQQsQMQgwEQxwEQowI6CwguEIAEELEDEIMBOhEILhCABBCxAxCDARDHARCvAToLCAAQgAQQsQMQgwE6DQguEMcBEK8BEEMQkwI6CgguEMcBEK8BEEM6BAgAEEM6CwguEIAEEMcBEK8BOggIABCABBDJAzoFCAAQkgM6DgguEIAEEMcBEK8BEJMCOgcILhCxAxAKOgcIABCxAxAKOgQIABAKOgQIABATOggIABAKEB4QEzoGCAAQHhATOgYIABANEB46BAgAEB46BggAEAoQHjoGCAAQCBAeOggIABAIEA0QHjoICAAQCBAKEB5KBQg6EgExSgUIPBIBMUoECEEYAFCWKFiTU2CKVWgCcAJ4AIABkwGIAaYNkgEDNy45mAEAoAEByAEDuAECwAEB&sclient=gws-wiz&ved=0ahUKEwjGkvXHr67yAhUK76QKHZ2pAEcQ4dUDCA0&uact=5#lrd=0x470fc3f3c0f0f433:0xc6a93a9350239ead,1,,,">
     Zobacz wszystkie opinie &nbsp;&nbsp; <img width="10px" height="15px" style={{verticalAlign:'middle', marginRight:'5px'}}   alt="poprzednia opinia klienta" src='/img/angle-right.svg'/> </a>
    </p>
    <br />
    </div>
    </>
  )
}

export default () => (
  <StaticQuery
    query={graphql`
      query SliderOpinions {
        allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "opinion-post"}}}, sort: {fields: frontmatter___date, order: ASC}) {
          edges {
            node {
              frontmatter {
                templateKey
                opinions {
                    opinion
                    name
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <SliderOpinions data={data} />}
  />
)
